import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Row, Table } from 'reactstrap'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { FModal, LoadingSpinner } from './../../components'
import Paginator from './../../components/Pagination/V2/Paginator'
import CashMahanService from './../../services/cashMahan/CashMahanService'
import CashMahanStatusBadge from './CashMahanStatusBadge'
import { CashMahanEmpty, CashMahanError } from './CashMahanStates'
import {
  apiErrorMessage,
  displayText,
  extractCollection,
  extractPagination,
  formatDate,
  formatMoney,
  isForbidden,
  isSuccess,
  recordId,
  rtlProps,
  settlePayload,
  technicianId,
  technicianLabel,
  unwrapData
} from './cashMahanUtils'

export default class Settlements extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      submitting: false,
      error: '',
      items: [],
      noResult: false,
      previousPages: [],
      nextPages: [],
      currentPage: 1,
      perPage: 15,
      fromDate: null,
      toDate: null,
      from: '',
      to: '',
      detailsModal: false,
      settleModal: false,
      selected: null,
      paymobSettlementReference: '',
      notes: '',
      verified: false,
      details: null,
      dashboard: null
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.load()
    this.loadDashboard()
  }

  loadDashboard() {
    CashMahanService.getDashboard((res) => {
      if (isSuccess(res)) {
        this.setState({ dashboard: unwrapData(res) })
      }
    })
  }

  dashboardValue(key) {
    const data = this.state.dashboard || {}
    if (data[key] !== undefined && data[key] !== null) {
      return data[key]
    }
    return null
  }

  queryParams() {
    return {
      page: this.state.currentPage,
      perPage: this.state.perPage,
      status: 'pending',
      from: this.state.from,
      to: this.state.to
    }
  }

  load() {
    this.setState({ loading: true, error: '' })
    CashMahanService.getSettlements(this.queryParams(), (res) => {
      if (isForbidden(res)) {
        this.setState({ loading: false })
        this.props.history.push('/403')
        return
      }
      if (!isSuccess(res)) {
        this.setState({ loading: false, error: apiErrorMessage(res), items: [], noResult: false })
        return
      }
      const data = unwrapData(res)
      const items = extractCollection(data, 'settlements')
      const pagination = extractPagination(data)
      this.setState({
        loading: false,
        error: '',
        items,
        noResult: !items.length,
        previousPages: pagination.previousPages,
        nextPages: pagination.nextPages,
        currentPage: pagination.currentPage || this.state.currentPage
      })
    })
  }

  changePage(page) {
    this.setState({ currentPage: page }, () => this.load())
  }

  handleDate(type, date) {
    const iso = date ? new Date(date + ' Z').toISOString().split('T')[0] : ''
    if (type === 'from') {
      this.setState({ fromDate: date, from: iso })
    } else {
      this.setState({ toDate: date, to: iso })
    }
  }

  openDetails(item) {
    const id = recordId(item)
    this.setState({ loading: true, selected: item, detailsModal: true, details: item })
    CashMahanService.getSettlement(id, (res) => {
      this.setState({ loading: false })
      if (isForbidden(res)) {
        this.props.history.push('/403')
        return
      }
      if (!isSuccess(res)) {
        alert(apiErrorMessage(res))
        return
      }
      const data = unwrapData(res)
      this.setState({ details: data.settlement || data })
    })
  }

  openSettle(item) {
    this.setState({
      settleModal: true,
      selected: item,
      paymobSettlementReference: '',
      notes: '',
      verified: false
    })
  }

  settle() {
    if (this.state.submitting) {
      return
    }
    if (!this.state.verified) {
      alert('Confirm that this settlement was verified in the Paymob dashboard')
      return
    }
    if (!String(this.state.paymobSettlementReference || '').trim()) {
      alert('Enter the Paymob settlement reference')
      return
    }
    const id = recordId(this.state.selected)
    this.setState({ submitting: true, loading: true })
    CashMahanService.settle(id, settlePayload(this.state.paymobSettlementReference, this.state.notes), (res) => {
      this.setState({ submitting: false, loading: false })
      if (isForbidden(res)) {
        this.props.history.push('/403')
        return
      }
      if (!isSuccess(res)) {
        alert(apiErrorMessage(res))
        return
      }
      this.setState({ settleModal: false, selected: null }, () => {
        this.load()
        this.loadDashboard()
      })
    })
  }

  renderFilters() {
    return (
      <Row>
        <Col md="3">
          <FormGroup>
            <Label>From</Label>
            <div className='date'>
              <DatePicker selected={this.state.fromDate} onChange={(date) => this.handleDate('from', date)} dateFormat="dd-MM-yyyy" placeholderText="From" />
            </div>
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <Label>To</Label>
            <div className='date'>
              <DatePicker selected={this.state.toDate} onChange={(date) => this.handleDate('to', date)} dateFormat="dd-MM-yyyy" placeholderText="To" />
            </div>
          </FormGroup>
        </Col>
        <Col md="2">
          <FormGroup>
            <Label>Per page</Label>
            <Input type="select" value={this.state.perPage} onChange={(e) => this.setState({ perPage: e.target.value })}>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md="4" style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Button className='actionsBtn' style={{ backgroundColor: '#3a4248', borderColor: '#3a4248', color: '#fff' }} onClick={() => this.setState({ currentPage: 1 }, () => this.load())}>Filter</Button>
          <Button className='actionsBtn' style={{ backgroundColor: '#a91010', borderColor: '#a91010', color: '#fff' }} onClick={() => this.setState({ fromDate: null, toDate: null, from: '', to: '', currentPage: 1 }, () => this.load())}>Reset</Button>
          <Button className='actionsBtn' onClick={() => this.load()}>Refresh</Button>
        </Col>
      </Row>
    )
  }

  renderDetails() {
    const item = this.state.details || this.state.selected || {}
    return (
      <div style={{ marginLeft: 10 }}>
        <p><i className="icon-arrow-right-circle"></i><span style={{ marginLeft: 6 }}>Technician: <strong {...rtlProps(technicianLabel(item))}>{technicianLabel(item)}</strong></span></p>
        <p><i className="icon-arrow-right-circle"></i><span style={{ marginLeft: 6 }}>Request reference: <strong>{displayText(item.requestReference)}</strong></span></p>
        <p><i className="icon-arrow-right-circle"></i><span style={{ marginLeft: 6 }}>Amount: <strong>{formatMoney(item.amount)}</strong></span></p>
        <p><i className="icon-arrow-right-circle"></i><span style={{ marginLeft: 6 }}>Paid date: <strong>{formatDate(item.paidDate || item.paidAt)}</strong></span></p>
        <p><i className="icon-arrow-right-circle"></i><span style={{ marginLeft: 6 }}>Paymob transaction reference: <strong>{displayText(item.paymobTransactionReference)}</strong></span></p>
        <p><i className="icon-arrow-right-circle"></i><span style={{ marginLeft: 6 }}>Status: <CashMahanStatusBadge item={item} /></span></p>
      </div>
    )
  }

  renderSettleForm() {
    return (
      <div>
        <p>Mark this settlement only after it was verified in the Paymob dashboard. The dashboard does not send settlement requests to Paymob.</p>
        {this.renderDetails()}
        <FormGroup>
          <Label>Paymob settlement reference</Label>
          <Input
            value={this.state.paymobSettlementReference}
            onChange={(e) => this.setState({ paymobSettlementReference: e.target.value })}
            placeholder="SETTLE-8891"
            disabled={this.state.submitting}
          />
        </FormGroup>
        <FormGroup>
          <Label>Notes</Label>
          <Input
            type="textarea"
            value={this.state.notes}
            onChange={(e) => this.setState({ notes: e.target.value })}
            placeholder="Confirmed in Paymob dashboard"
            disabled={this.state.submitting}
          />
        </FormGroup>
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              checked={this.state.verified}
              disabled={this.state.submitting}
              onChange={(e) => this.setState({ verified: e.target.checked })}
            />
            I confirm this settlement was verified in Paymob
          </Label>
        </FormGroup>
      </div>
    )
  }

  render() {
    return (
      <div className="app align-items-center">
        <Container>
          {this.state.dashboard ? (
            <Row>
              <Col md="4">
                <Card className="text-white shadow" style={{ backgroundColor: '#4dbd74', marginBottom: 16 }}>
                  <CardBody>
                    <div>Collected money</div>
                    <strong>{formatMoney(this.dashboardValue('collectedMoney'))}</strong>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="text-white shadow" style={{ backgroundColor: '#f0ad4e', marginBottom: 16 }}>
                  <CardBody>
                    <div>Pending settlements</div>
                    <strong>{formatMoney(this.dashboardValue('pendingSettlements'))}</strong>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="text-white shadow" style={{ backgroundColor: '#20a8d8', marginBottom: 16 }}>
                  <CardBody>
                    <div>Technician balances</div>
                    <strong>{formatMoney(this.dashboardValue('technicianBalances'))}</strong>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : null}
          {this.renderFilters()}
          <Card>
            <CardHeader className='shadow'>
              <i className="fa fa-align-justify"></i>
              <span style={{ marginLeft: 6 }}>Pending settlement queue</span>
            </CardHeader>
            {this.state.error ? (
              <CashMahanError message={this.state.error} onRetry={() => this.load()} />
            ) : this.state.noResult ? (
              <CashMahanEmpty message="There's no pending settlement" />
            ) : (
              <CardBody className='shadow'>
                <Table hover bordered striped responsive size="md">
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'center' }}>Technician</th>
                      <th style={{ textAlign: 'center' }}>Request reference</th>
                      <th style={{ textAlign: 'center' }}>Amount</th>
                      <th style={{ textAlign: 'center' }}>Paid date</th>
                      <th style={{ textAlign: 'center' }}>Paymob transaction reference</th>
                      <th style={{ textAlign: 'center' }}>Details</th>
                      <th style={{ textAlign: 'center' }}>Settle</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.items.map((item, index) => {
                      const fixerId = technicianId(item)
                      return (
                        <tr key={recordId(item) || index}>
                          <td style={{ textAlign: 'center', ...rtlProps(technicianLabel(item)).style }}>
                            {fixerId ? (
                              <Button className="click" style={{ backgroundColor: 'transparent', borderColor: 'transparent', fontWeight: 'bold' }} onClick={() => this.props.history.push(`/cash-mahan/technicians/${fixerId}/wallet`)}>
                                {technicianLabel(item)}
                              </Button>
                            ) : technicianLabel(item)}
                          </td>
                          <td style={{ textAlign: 'center' }}>{displayText(item.requestReference)}</td>
                          <td style={{ textAlign: 'center' }}>{formatMoney(item.amount)}</td>
                          <td style={{ textAlign: 'center' }}>{formatDate(item.paidDate || item.paidAt)}</td>
                          <td style={{ textAlign: 'center' }}>{displayText(item.paymobTransactionReference)}</td>
                          <td style={{ textAlign: 'center' }}>
                            <Button className='actionsBtn' onClick={() => this.openDetails(item)}>View</Button>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <Button className='actionsBtn' disabled={this.state.submitting} onClick={() => this.openSettle(item)}>Settle</Button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
                <Paginator prevPages={this.state.previousPages} nextPages={this.state.nextPages} notify={(page) => this.changePage(page)} />
              </CardBody>
            )}
          </Card>
          <FModal
            title="Settlement details"
            className="modal-lg"
            content={this.renderDetails()}
            state={this.state.detailsModal}
            onClose={() => this.setState({ detailsModal: false, details: null })}
            noSubmitBtn={true}
          />
          <FModal
            title="Confirm Paymob settlement"
            content={this.renderSettleForm()}
            state={this.state.settleModal}
            onClose={() => !this.state.submitting && this.setState({ settleModal: false })}
            onSubmit={() => this.settle()}
          />
          <LoadingSpinner loading={this.state.loading} />
        </Container>
      </div>
    )
  }
}
